import { Injectable } from '@angular/core';

import { UserService } from '../services/user.service';

import { NavigationOptions } from '../models/navigation';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    constructor(private _userService: UserService) { }

    public getNewNavigationOptions(): NavigationOptions {
        let navigationOptions: NavigationOptions;
        navigationOptions = {
            titles: {
                displayBlank: true,
                displayAuthentication: false,
                displayAuthenticationForgotPassword: false,
                displayAuthenticationForgotUsername: false,
                displayRegistration: false,
                displayMultifactorVerify: false,
                displaySecurityQuestion: false
            },
            menuOptions: {
                displayHome: false,
                displayContactUs: false,
                displayLogin: false,
                displayLogout: false,
                displayProfile: false,
                displayLoanDetails: false,
                displayPayments: false,
                displayMilitaryBenefits: false,
                displayFAQ: false,
                displayResources: false,
                displayQuickPayLogin: false
            },
            footerOptions: {
                displayHoursOfOperation: false
            }
        };
        return navigationOptions;
    }

    public getNavigationOptionsForPath(path: string = null): NavigationOptions {
        const navigationOptions: NavigationOptions = this.getNewNavigationOptions();

        // 11/03/2021 RA - Added for ForgotUsername & ForgotPassord Screen Formatting
        if ((path.toLowerCase().trim() === 'contactus' || path.toLowerCase().trim() === 'forgotusername' ||
            path.toLowerCase().trim() === 'forgotpassword') && !this._userService.isLoggedIn(false) &&
            !this._userService.hasParticipantId()) {
            path = 'contactus_no_login';
        }

        if (
            path.toLowerCase().trim() === 'contactus' &&
            this._userService.isLoggedIn(false) &&
            !this._userService.hasSecurityQuestionSetupFlag()
        ) {
            path = 'contactus_no_security_question';
        }

        if (path.toLowerCase() !== null) {
            switch (path.toLowerCase().trim()) {
                case 'login': {
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayQuickPayLogin = true;
                    break;
                }
                case 'quickpay': {
                  navigationOptions.footerOptions.displayHoursOfOperation = false;
                  navigationOptions.menuOptions.displayLogin = true;
                  navigationOptions.menuOptions.displayQuickPayLogin = true;
                  navigationOptions.menuOptions.displayContactUs = true;
                  break;
                }
                case 'contactus_no_login': {
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    navigationOptions.menuOptions.displayLogin = true;
                    navigationOptions.menuOptions.displayQuickPayLogin = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    break;
                }
                case 'contactus_no_security_question': {
                    navigationOptions.footerOptions.displayHoursOfOperation = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    break;
                }
                case 'loginonetime': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displayAuthentication = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    break;
                }
                case 'forgotusername': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displayAuthenticationForgotUsername = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogin = true;
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    break;
                }
                case 'forgotpassword': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displayAuthenticationForgotPassword = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogin = true;
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    break;
                }
                case 'register': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displayRegistration = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogin = false;
                    navigationOptions.footerOptions.displayHoursOfOperation = false;
                    break;
                }
                case 'verify': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displayMultifactorVerify = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogin = false;
                    navigationOptions.footerOptions.displayHoursOfOperation = true;
                    break;
                }
                case 'securityquestion': {
                    navigationOptions.titles.displayBlank = false;
                    navigationOptions.titles.displaySecurityQuestion = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogin = false;
                    navigationOptions.footerOptions.displayHoursOfOperation = true;
                    break;
                }
                default: {
                    navigationOptions.menuOptions.displayHome = true;
                    navigationOptions.menuOptions.displayContactUs = true;
                    navigationOptions.menuOptions.displayLogout = true;
                    navigationOptions.menuOptions.displayProfile = true;
                    navigationOptions.menuOptions.displayLoanDetails = true;
                    navigationOptions.menuOptions.displayPayments = true;
                    navigationOptions.menuOptions.displayFAQ = true;
                    navigationOptions.menuOptions.displayResources = true;
                    navigationOptions.footerOptions.displayHoursOfOperation = true;
                    break;
                }
            }
        }
        return navigationOptions;
    }

    public isNavigationTwoRows(path: string = null): boolean {
        let isNavigationTwoRows = false;

        // 11/03/2021 RA - Added for ForgotUsername & ForgotPassord Screen Formatting
        if ((path.toLowerCase().trim() === 'contactus' || path.toLowerCase().trim() === 'forgotusername' ||
            path.toLowerCase().trim() === 'forgotpassword') && !this._userService.isLoggedIn(false) && !this._userService.hasParticipantId()) {
            path = 'contactus_no_login';
        }

        if (
            path.toLowerCase().trim() === 'contactus' &&
            this._userService.isLoggedIn(false) &&
            !this._userService.hasSecurityQuestionSetupFlag()
        ) {
            path = 'contactus_no_security_question';
        }

        if (path !== null) {
            switch (path.toLowerCase().trim()) {
                case 'login':
                case 'quickpay':
                case 'contactus_no_login':
                case 'contactus_no_security_question':
                // case 'FORGOTUSERNAME':      // 11/02/2021 RA - Removed to display correctly in Mobile
                // case 'FORGOTPASSWORD':      // 11/02/2021 RA - Removed to display correctly in Mobile
                // case 'REGISTER':            // 11/02/2021 RA - Removed to display correctly in Mobile
                case 'loginonetime':
                case 'securityquestion': {
                    isNavigationTwoRows = false;
                    break;
                }
                default: {
                    isNavigationTwoRows = true;
                    break;
                }
            }
        }
        return isNavigationTwoRows;
    }
}
